import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="App min-h-screen bg-background">
      <Header />
      <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center sm:px-6" data-testid="payment-cancel">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <XCircle className="h-9 w-9" />
        </div>
        <h1 className="mt-5 font-display text-3xl font-800 text-secondary">Paiement annulé</h1>
        <p className="mt-2 text-muted-foreground">Aucun montant n'a été prélevé. Vous pouvez réessayer quand vous le souhaitez.</p>
        <div className="mt-6 flex gap-3">
          <Button onClick={() => nav("/premium")} className="rounded-full" data-testid="cancel-retry">Revoir Premium</Button>
          <Button onClick={() => nav("/comparateur")} variant="outline" className="rounded-full">Continuer gratuitement</Button>
        </div>
      </div>
    </div>
  );
}
